import { useState } from 'react'

export const DEFAULT_PAGE_SIZE = 10

/**
 * Page a sorted list, largest-first, so a chart stays a readable fixed height
 * instead of growing without bound.
 *
 * Pagination rather than a scroll box is deliberate: in a horizontal bar chart
 * the x-axis renders at the bottom of the SVG, so a fixed-height scroll
 * container scrolls the scale out of view and leaves the reader comparing bar
 * lengths against nothing.
 *
 * The page index is clamped on read rather than reset in an effect. Filters and
 * date changes shrink the data underneath us constantly, and clamping means a
 * narrowing filter can never strand the view on an empty page -- no effect, no
 * extra render, no stale-state window.
 */
const usePagination = (items = [], pageSize = DEFAULT_PAGE_SIZE) => {
    const [page, setPage] = useState(0)

    const pageCount = Math.max(1, Math.ceil(items.length / pageSize))
    const safePage = Math.min(Math.max(page, 0), pageCount - 1)
    const start = safePage * pageSize
    const pageItems = items.slice(start, start + pageSize)

    return {
        pageItems,
        page: safePage,
        pageCount,
        setPage,
        start,
        total: items.length,
    }
}

export default usePagination
